import api from "services/api";

/**
 * Shared /initial-settings reader.
 *
 * The payload is read by many independent call sites (auth modal, OTP screen,
 * layout feature flags, cashier, idle/access checks), each of which used to fire
 * its own request. One in-memory promise per page load collapses those into a
 * single call. It is deliberately NOT persisted: a reload always refetches, so a
 * back-office change is never hidden behind a stale cache.
 */

let pending = null;

export function getInitialSettings() {
  if (pending) return pending;
  pending = (async () => {
    try {
      const res = await api.get("/initial-settings");
      if (res.status === 200 && res.data) return res.data;
    } catch (e) {
      // fall through: callers handle null with their own defaults
    }
    // A failed attempt is not cached, so the next caller retries.
    pending = null;
    return null;
  })();
  return pending;
}
